import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { ROLE_TYPE_OPTIONS } from 'duties/roles/RoleTypeSettings'

const options = [
  ...ROLE_TYPE_OPTIONS.map((opt) => ({
    label: opt.label,
    value: opt.value
  })),
  { label: 'Unassigned', value: 'unassigned' }
]

function RoleTypeDropdown({ filterParams, setFilterParams }) {
  const [selected, setSelected] = useState(null)

  return (
    <Select
      options={options}
      value={selected}
      isClearable={true}
      placeholder="Select Type"
      onChange={(val) => {
        setSelected(val)
        setFilterParams({ ...filterParams, role_type: val?.value || '', page: 1 })
      }}
      id="role-type-selector"
      styles={{ menu: (base) => ({ ...base, zIndex: 20 }) }}
    />
  )
}

RoleTypeDropdown.propTypes = {
  filterParams: PropTypes.object.isRequired,
  setFilterParams: PropTypes.func.isRequired
}

export default RoleTypeDropdown
